"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signUp = void 0;
const token_1 = require("../storage/token");
const md5_1 = require("../utils/md5");
const base_1 = require("./base");
const const_1 = require("./const");
const signUp = (email, password, code) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/users/register", {
        email,
        password: (0, md5_1.generateMD5Hash)(password),
        code,
    }).then((res) => {
        const token = res;
        if (typeof token === "string") {
            (0, token_1.saveToken)(token);
            return true;
        }
        else if ("token" in token) {
            // If the response is an object with a token property
            (0, token_1.saveToken)(token.token);
            return true;
        }
        return false;
    });
});
exports.signUp = signUp;
